export default "__VITE_ASSET__abf44553__$_?component__"